module.exports = __webpack_public_path__ + "img/lang-ar.eae20b16.png";